import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class VehiclesFlowNotificationService {

    private sidenav: MatSidenav

    public newNotification: BehaviorSubject<boolean>;

    private base_url: string;

    constructor() {
        this.base_url = environment.base_url;
        this.newNotification = new BehaviorSubject(false);
    }

    public setNewNotification(bool: boolean) {
        this.newNotification.next(bool)
    }
}


